import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const spacerVariants = cva(
  [
    'border-0 bg-transparent',
    'h-0 w-full pb-spacing-lg',
    'lg:h-full lg:shrink-0 lg:grow-0 lg:pb-0'
  ],
  {
    variants: {
      variant: {
        xs: 'lg:w-spacing-xs',
        'col-1': 'lg:w-col-span-1',
        'col-2': 'lg:w-col-span-2',
        'col-3': 'lg:w-col-span-3',
        'col-4': 'lg:w-col-span-4',
        'col-5': 'lg:w-col-span-5',
        'col-6': 'lg:w-col-span-6'
      }
    }
  }
)

export type SpacerProps = HTMLAttributes<HTMLHRElement> &
  VariantProps<typeof spacerVariants>

const Spacer = ({ variant, className, ...props }: SpacerProps) => {
  return (
    <hr className={cn(spacerVariants({ variant, className }))} {...props} />
  )
}

export default Spacer
